<template>
    <HamletTable
        :fetch="fetch"
        :columns="columns"
        :default-per-page="savedPerPage"
        :default-page="savedPage"
        @onRowClick="edit"
        @per-page-change="onPerPageChange"
        @page-change="onPageChange"
    >
        <template #header-label>
            {{ $t('Page(Legislations):Component(Text):page-label') }}
        </template>

        <template #header-controls>
            <Button
                class="mt-0 btn-icon"
                @click="add"
                v-if="$can('visit', 'administration-legislations-add')"
            >
                <feather-icon icon="PlusIcon" />
            </Button>
        </template>

        <template #cell-status="data">
            <b-badge :variant="data.item.status === 'published' ? 'success' : 'secondary'">
                {{ data.item.status }}
            </b-badge>
        </template>

        <template #cell-validFrom="data">
            {{ renderDate(data.item.validFrom) }}
        </template>

        <template #cell-validTo="data">
            <OngoingDateBadge :date="data.item.validTo" />
        </template>
    </HamletTable>
</template>

<script>
import {BBadge} from 'bootstrap-vue'
import {LegislationApi} from "@core/api";
import Ripple from 'vue-ripple-directive'
import OngoingDateBadge from "@core/components/common/OngoingDateBadge.vue";
import dateRenderer from "@core/mixins/date-renderer";
import {Button, HamletTable} from "@core/components/common";

const DEFAULT_PER_PAGE = 10;
const SETTINGS_KEY = 'legislationGridSettings';

function normalizeSettings(settings) {
    if (!settings || typeof settings !== 'object' || Array.isArray(settings)) {
        return {
            perPage: DEFAULT_PER_PAGE,
            page: 1,
        };
    }

    return {
        perPage: Number(settings.perPage) || DEFAULT_PER_PAGE,
        page: Number(settings.page) || 1,
    };
}

export default {
    mixins: [dateRenderer],
    directives: {Ripple},
    components: {
        HamletTable, BBadge, OngoingDateBadge, Button
    },
    data() {
        const savedSettings = normalizeSettings(this.$store.getters.runtimeConfig[SETTINGS_KEY]);

        return {
            savedPerPage: savedSettings.perPage,
            savedPage: savedSettings.page,
            columns: [
                // {
                //     key: 'id',
                //     label: this.$t('Component(Grid):column-id')
                // },
                {
                    key: 'status',
                    label: 'Status'
                },
                {
                    key: 'title',
                    label: this.$t('Component(Grid):column-name')
                },
                {
                    key: 'shortName',
                    label: this.$t('Component(Grid):column-short-name')
                },
                {
                    key: 'regulationId',
                    label: this.$t('Component(Grid):column-regulation-id')
                },
                {
                    key: 'regulationType',
                    label: this.$t('Component(Grid):column-regulation-type')
                },
                {
                    key: 'restrictedBy',
                    label: this.$t('Component(Grid):column-restricted-by')
                },
                {
                    key: 'substanceList',
                    label: this.$t('Component(Grid):column-substance-list')
                },
                {
                    key: 'coveredWeight',
                    label: this.$t('Component(Grid):column-covered-weight')
                },
                {
                    key: 'validFrom',
                    label: this.$t('Component(Grid):column-valid-from')
                },
                {
                    key: 'validTo',
                    label: this.$t('Component(Grid):column-valid-to')
                },
            ],
        }
    },
    methods: {
        fetch(config, cb) {
            this.savedPage = config.page;
            this.savedPerPage = config.perPage;
            this.saveSettings();

            LegislationApi
                .grid([], {}, config.page, config.perPage)
                .then(r => {
                    cb(r.data.totalItems, r.data.items);
                })
            ;
        },
        add() {
            this.$router.push({
                name: 'administration-legislations-add',
            });
        },
        edit(legislation) {
            if (this.$can('visit', 'administration-legislations-add')) {
                this.$router.push({
                    name: 'administration-legislations-edit',
                    params: {id: legislation.id}
                });
            }
        },
        onPerPageChange(perPage) {
            this.savedPerPage = perPage;
            this.saveSettings();
        },
        onPageChange(page) {
            this.savedPage = page;
            this.saveSettings();
        },
        saveSettings() {
            this.$store.dispatch('setRuntimeProperty', {
                name: SETTINGS_KEY,
                value: {
                    perPage: this.savedPerPage,
                    page: this.savedPage,
                },
                removeOnOrganizationSwitch: true,
            });
        }
    },
}
</script>
